import {Type} from 'class-transformer';
import {PlanningParameterItem} from '../planning-parameter-item/planning-parameter-item';
import {Manufacturer} from '../manufacturer/manufacturer';

export class PlanningParameter {
    public readonly id!: string;
    public readonly name!: string;

    @Type(() => Manufacturer)
    public readonly manufacturer!: Manufacturer;

    @Type(() => PlanningParameterItem)
    public items!: PlanningParameterItem[];

    @Type(() => Date)
    public readonly created!: Date;
}
